import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() levelMenu: any;
  @Input() levelMenuOther: any;
  @Input() title: any = null;
  @Input() isSecondLevelUp: boolean = false;
  public itemBreadcrumb: any;

  constructor(
    public helpersService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.itemBreadcrumb = this.levelMenu && this.levelMenu.length && this.levelMenu.length >= 1 ? this.levelMenu : this.levelMenuOther;
  }

}
